import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  Row,
  Typography
} from '@vivaldis/antd-ui'
import { Divider } from '../../../../../../../Divider'
import { useForm } from '../../../../provider/FormProvider'
import { CountryType } from '../../../../../../types/CountryType'

interface Props {
  countries: CountryType[]
}

export const IdCard = ({ countries }: Props) => {
  const [t] = useTranslation('web_ui')
  const { values } = useForm()

  // we show ID CARD when user selected `eeaMember` country or when country is not selected yet
  const isEeaMember = useMemo(() => {
    if (!values.nationalityCountryId) {
      return true
    }

    return !!countries.find(
      country => country.id === values.nationalityCountryId
    )?.eeaMember
  }, [countries, values.nationalityCountryId])

  if (!values.nationalityCountryId) {
    return null
  }

  if (!isEeaMember) {
    return null
  }

  return (
    <>
      <Divider sectionSeparator />
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_personal_information_form.steps.enter_ssn.id_card_section_header'
        )}
      </Typography.Title>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="idCardFrontPicture"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.id_card_front_picture.label'
            )}
          >
            <Image
              width={250}
              height={160}
              src={String(values.idCardFrontPicture)}
              preview={false}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="idCardBackPicture"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.id_card_back_picture.label'
            )}
          >
            <Image
              width={250}
              height={160}
              src={String(values.idCardBackPicture)}
              preview={false}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="idCardNumber"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.id_card_number.label'
            )}
          >
            <Input
              name="idCardNumber"
              placeholder={t('form.required')}
              autoComplete="off"
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="idCardExpiresOn"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.id_card_expires_on.label'
            )}
          >
            <DatePicker
              name="idCardExpiresOn"
              format="dd-MM-yyyy"
              placeholder={t('form.required')}
              style={{ width: '100%' }}
              autoComplete="off"
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
